import { render } from "./BoardPort.vue?vue&type=template&id=1b922548&ts=true"
import script from "./BoardPort.vue?vue&type=script&lang=ts"
export * from "./BoardPort.vue?vue&type=script&lang=ts"

import "./BoardPort.vue?vue&type=style&index=0&id=1b922548&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__